import React from "react";
import { Link } from "react-router-dom";
import { Save, Undo2, Monitor, Smartphone, LayoutDashboard } from "lucide-react";
import { useLayout } from "../../context/LayoutContext";

export const EditorBar = () => {
  const { editing, device, setDevice, save, discard, dirty, saving } = useLayout();
  if (!editing) return null;
  return (
    <div
      className="fixed bottom-4 start-1/2 -translate-x-1/2 rtl:translate-x-1/2 z-[60] flex items-center gap-2 rounded-full bg-charcoal/95 border border-white/15 px-3 py-2 shadow-[0_20px_50px_rgba(0,0,0,0.45)]"
      data-testid="editor-bar"
    >
      <span className="text-gold text-xs font-semibold px-2 hidden sm:inline">Düzenleme Modu</span>
      <div className="flex gap-1 p-1 rounded-full bg-white/10">
        <button onClick={() => setDevice("desktop")} data-testid="editor-device-desktop" title="Masaüstü boyutları" className={`w-8 h-8 rounded-full flex items-center justify-center ${device === "desktop" ? "bg-gold text-charcoal" : "text-white/70"}`}>
          <Monitor className="w-4 h-4" />
        </button>
        <button onClick={() => setDevice("mobile")} data-testid="editor-device-mobile" title="Mobil boyutları" className={`w-8 h-8 rounded-full flex items-center justify-center ${device === "mobile" ? "bg-gold text-charcoal" : "text-white/70"}`}>
          <Smartphone className="w-4 h-4" />
        </button>
      </div>
      <button onClick={discard} disabled={!dirty} data-testid="editor-discard" className="inline-flex items-center gap-1.5 text-xs text-white/80 px-3 py-2 rounded-full hover:bg-white/10 disabled:opacity-40 transition-colors">
        <Undo2 className="w-4 h-4" /> Geri Al
      </button>
      <button onClick={save} disabled={!dirty || saving} data-testid="editor-save" className="inline-flex items-center gap-1.5 text-xs font-semibold bg-gold text-charcoal px-4 py-2 rounded-full hover:bg-gold-soft disabled:opacity-50 transition-colors">
        <Save className="w-4 h-4" /> {saving ? "Kaydediliyor" : "Kaydet"}
      </button>
      <Link to="/admin" data-testid="editor-exit" title="Yönetim paneli" className="w-8 h-8 rounded-full flex items-center justify-center text-white/70 hover:bg-white/10">
        <LayoutDashboard className="w-4 h-4" />
      </Link>
    </div>
  );
};
